"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokensSearchParamsCreator = void 0;
const types_1 = require("@framework/types");
const types_2 = require("../types");
const tokensSearchParamsCreator = profile => ({
    [types_2.ServiceType.ADMIN]: {
        tokenStatus: [types_1.TokenStatus.MINTED],
        contractIds: [],
        templateIds: [],
        [`metadata.${types_1.TokenMetadata.RARITY}`]: [],
        [`metadata.${types_1.TokenMetadata.LEVEL}`]: [],
    },
    [types_2.ServiceType.OFFICE]: {
        tokenStatus: [types_1.TokenStatus.MINTED],
        contractIds: [],
        templateIds: [],
        [`metadata.${types_1.TokenMetadata.RARITY}`]: [],
        [`metadata.${types_1.TokenMetadata.LEVEL}`]: [],
        merchantId: profile.merchantId,
    },
});
exports.tokensSearchParamsCreator = tokensSearchParamsCreator;
//# sourceMappingURL=tokens-search-params.js.map